import React from 'react'
import { useJobsStore } from '../../../Store/useJobsStore'

export const useFilters = () => {
    const allFilters = useJobsStore((state) => state.allFilters)

    return { allFilters }
}
